
    <template>
      <section class="relax-doc">
        <h1>Menu 导航菜单</h1>
<blockquote>
<p>为页面和功能提供导航的菜单列表</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>水平的顶部导航菜单</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-menu mode=&quot;horizontal&quot;&gt;
    &lt;x-menu-item name=&quot;1&quot;&gt;导航一&lt;/x-menu-item&gt;
    &lt;x-sub-menu name=&quot;2&quot;&gt;
      &lt;template #title&gt;导航二&lt;/template&gt;
      &lt;x-menu-item-group title=&quot;小标题&quot;&gt;
        &lt;x-menu-item name=&quot;2-1&quot;&gt;子菜单一&lt;/x-menu-item&gt;
        &lt;x-menu-item name=&quot;2-2&quot;&gt;子菜单二&lt;/x-menu-item&gt;
      &lt;/x-menu-item-group&gt;
    &lt;/x-sub-menu&gt;
    &lt;x-sub-menu name=&quot;3&quot;&gt;
      &lt;template #title&gt;导航三&lt;/template&gt;
      &lt;x-menu-item-group&gt;
        &lt;x-menu-item name=&quot;3-1&quot;&gt;子菜单一&lt;/x-menu-item&gt;
        &lt;x-menu-item name=&quot;3-2&quot;&gt;子菜单二&lt;/x-menu-item&gt;
      &lt;/x-menu-item-group&gt;
    &lt;/x-sub-menu&gt;
    &lt;x-menu-item name=&quot;4&quot;&gt;导航四&lt;/x-menu-item&gt;
  &lt;/x-menu&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="chui-zhi-cai-dan"><a class="header-anchor" href="#chui-zhi-cai-dan"></a> 垂直菜单</h2>
<blockquote>
<p>垂直菜单，可内嵌子菜单，目前仅支持二级菜单</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-menu style=&quot;width: 256px&quot; &gt;
    &lt;x-menu-item name=&quot;1&quot;&gt;导航一&lt;/x-menu-item&gt;
    &lt;x-sub-menu name=&quot;2&quot;&gt;
      &lt;template #title&gt;导航二&lt;/template&gt;
      &lt;x-menu-item-group title=&quot;小标题&quot;&gt;
        &lt;x-menu-item name=&quot;2-1&quot;&gt;子菜单一&lt;/x-menu-item&gt;
        &lt;x-menu-item name=&quot;2-2&quot;&gt;子菜单二&lt;/x-menu-item&gt;
      &lt;/x-menu-item-group&gt;
    &lt;/x-sub-menu&gt;
    &lt;x-sub-menu name=&quot;3&quot;&gt;
      &lt;template #title&gt;导航三&lt;/template&gt;
      &lt;x-menu-item-group&gt;
        &lt;x-menu-item name=&quot;3-1&quot;&gt;子菜单一&lt;/x-menu-item&gt;
        &lt;x-menu-item name=&quot;3-2&quot;&gt;子菜单二&lt;/x-menu-item&gt;
      &lt;/x-menu-item-group&gt;
    &lt;/x-sub-menu&gt;
    &lt;x-menu-item name=&quot;4&quot;&gt;导航四&lt;/x-menu-item&gt;
  &lt;/x-menu&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="zhi-zhan-kai-dang-qian-cai-dan"><a class="header-anchor" href="#zhi-zhan-kai-dang-qian-cai-dan"></a> 只展开当前菜单</h2>
<blockquote>
<p>点击菜单，收起其他展开的所有菜单，保持菜单聚焦简洁</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-menu style=&quot;width: 256px&quot; :uniqueOpened=&quot;true&quot;&gt;
    &lt;x-menu-item name=&quot;1&quot;&gt;导航一&lt;/x-menu-item&gt;
    &lt;x-sub-menu name=&quot;2&quot;&gt;
      &lt;template #title&gt;导航二&lt;/template&gt;
      &lt;x-menu-item-group title=&quot;小标题&quot;&gt;
        &lt;x-menu-item name=&quot;2-1&quot;&gt;子菜单一&lt;/x-menu-item&gt;
        &lt;x-menu-item name=&quot;2-2&quot;&gt;子菜单二&lt;/x-menu-item&gt;
      &lt;/x-menu-item-group&gt;
    &lt;/x-sub-menu&gt;
    &lt;x-sub-menu name=&quot;3&quot;&gt;
      &lt;template #title&gt;导航三&lt;/template&gt;
      &lt;x-menu-item-group&gt;
        &lt;x-menu-item name=&quot;3-1&quot;&gt;子菜单一&lt;/x-menu-item&gt;
        &lt;x-menu-item name=&quot;3-2&quot;&gt;子菜单二&lt;/x-menu-item&gt;
      &lt;/x-menu-item-group&gt;
    &lt;/x-sub-menu&gt;
    &lt;x-menu-item name=&quot;4&quot;&gt;导航四&lt;/x-menu-item&gt;
  &lt;/x-menu&gt;
&lt;/template&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_menu_item = _resolveComponent("x-menu-item")
  const _component_x_menu_item_group = _resolveComponent("x-menu-item-group")
  const _component_x_sub_menu = _resolveComponent("x-sub-menu")
  const _component_x_menu = _resolveComponent("x-menu")

  return (_openBlock(), _createBlock(_component_x_menu, { mode: "horizontal" }, {
    default: _withCtx(() => [
      _createVNode(_component_x_menu_item, { name: "1" }, {
        default: _withCtx(() => [
          _createTextVNode("导航一")
        ]),
        _: 1
      }),
      _createVNode(_component_x_sub_menu, { name: "2" }, {
        title: _withCtx(() => [
          _createTextVNode("导航二")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_x_menu_item_group, { title: "小标题" }, {
            default: _withCtx(() => [
              _createVNode(_component_x_menu_item, { name: "2-1" }, {
                default: _withCtx(() => [
                  _createTextVNode("子菜单一")
                ]),
                _: 1
              }),
              _createVNode(_component_x_menu_item, { name: "2-2" }, {
                default: _withCtx(() => [
                  _createTextVNode("子菜单二")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_x_sub_menu, { name: "3" }, {
        title: _withCtx(() => [
          _createTextVNode("导航三")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_x_menu_item_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_x_menu_item, { name: "3-1" }, {
                default: _withCtx(() => [
                  _createTextVNode("子菜单一")
                ]),
                _: 1
              }),
              _createVNode(_component_x_menu_item, { name: "3-2" }, {
                default: _withCtx(() => [
                  _createTextVNode("子菜单二")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_x_menu_item, { name: "4" }, {
        default: _withCtx(() => [
          _createTextVNode("导航四")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_menu_item = _resolveComponent("x-menu-item")
  const _component_x_menu_item_group = _resolveComponent("x-menu-item-group")
  const _component_x_sub_menu = _resolveComponent("x-sub-menu")
  const _component_x_menu = _resolveComponent("x-menu")

  return (_openBlock(), _createBlock(_component_x_menu, { style: {"width":"256px"} }, {
    default: _withCtx(() => [
      _createVNode(_component_x_menu_item, { name: "1" }, {
        default: _withCtx(() => [
          _createTextVNode("导航一")
        ]),
        _: 1
      }),
      _createVNode(_component_x_sub_menu, { name: "2" }, {
        title: _withCtx(() => [
          _createTextVNode("导航二")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_x_menu_item_group, { title: "小标题" }, {
            default: _withCtx(() => [
              _createVNode(_component_x_menu_item, { name: "2-1" }, {
                default: _withCtx(() => [
                  _createTextVNode("子菜单一")
                ]),
                _: 1
              }),
              _createVNode(_component_x_menu_item, { name: "2-2" }, {
                default: _withCtx(() => [
                  _createTextVNode("子菜单二")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_x_sub_menu, { name: "3" }, {
        title: _withCtx(() => [
          _createTextVNode("导航三")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_x_menu_item_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_x_menu_item, { name: "3-1" }, {
                default: _withCtx(() => [
                  _createTextVNode("子菜单一")
                ]),
                _: 1
              }),
              _createVNode(_component_x_menu_item, { name: "3-2" }, {
                default: _withCtx(() => [
                  _createTextVNode("子菜单二")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_x_menu_item, { name: "4" }, {
        default: _withCtx(() => [
          _createTextVNode("导航四")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_menu_item = _resolveComponent("x-menu-item")
  const _component_x_menu_item_group = _resolveComponent("x-menu-item-group")
  const _component_x_sub_menu = _resolveComponent("x-sub-menu")
  const _component_x_menu = _resolveComponent("x-menu")

  return (_openBlock(), _createBlock(_component_x_menu, {
    style: {"width":"256px"},
    uniqueOpened: true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_x_menu_item, { name: "1" }, {
        default: _withCtx(() => [
          _createTextVNode("导航一")
        ]),
        _: 1
      }),
      _createVNode(_component_x_sub_menu, { name: "2" }, {
        title: _withCtx(() => [
          _createTextVNode("导航二")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_x_menu_item_group, { title: "小标题" }, {
            default: _withCtx(() => [
              _createVNode(_component_x_menu_item, { name: "2-1" }, {
                default: _withCtx(() => [
                  _createTextVNode("子菜单一")
                ]),
                _: 1
              }),
              _createVNode(_component_x_menu_item, { name: "2-2" }, {
                default: _withCtx(() => [
                  _createTextVNode("子菜单二")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_x_sub_menu, { name: "3" }, {
        title: _withCtx(() => [
          _createTextVNode("导航三")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_x_menu_item_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_x_menu_item, { name: "3-1" }, {
                default: _withCtx(() => [
                  _createTextVNode("子菜单一")
                ]),
                _: 1
              }),
              _createVNode(_component_x_menu_item, { name: "3-2" }, {
                default: _withCtx(() => [
                  _createTextVNode("子菜单二")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_x_menu_item, { name: "4" }, {
        default: _withCtx(() => [
          _createTextVNode("导航四")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  